import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

export const FirmDocumentsFilterActionBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.brand[500],
    border: `1px solid ${theme.palette.neutral.white}`,
    color: theme.palette.neutral.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: 9,
    fontWeight: 700,
    height: 14,
    lineHeight: '14px',
    minWidth: 14,
    padding: '0 3px',
    right: -4,
    top: 3,
  },
}));

export const FirmDocumentsFilterTooltip = styled('span')(({ theme }) => ({
  display: 'grid',
  gap: 2,
  whiteSpace: 'pre-line',

  '& [data-firm-documents-filter-tooltip-title="true"]': {
    color: theme.palette.neutral.white,
    fontWeight: 600,
  },
}));

export const FirmDocumentsBulkActionEndIcon = styled('span')(({ theme }) => ({
  alignItems: 'center',
  display: 'inline-flex',
  gap: 3,

  '& [data-firm-documents-bulk-action-count="true"]': {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    minWidth: '3ch',
    textAlign: 'left',
  },
}));

export const FirmDocumentsRoot = styled('main')(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  boxSizing: 'border-box',
  height: '100%',
  minHeight: 0,
  width: '100%',
}));
